import React, {useState} from 'react';
import {connect} from "react-redux";
import DocumentUploader from "./DocumentUploader";
import {nextStepAction, prevStepAction} from "~/redux/actions/guests";
import StepsNavigation from '../StepsNavigation';
import TextTranslate, { TextTranslateString } from '../../../Components/TextTranslate/TextTranslate';

const Documents = ({
    guests,
    formData,
    activeGuest,
    activeStep,
    isAdmin = false,
    ...props}) =>
{

    const [passportError, setPassportError] = useState('');
    const [accreditationError, setAccreditationError] = useState('');

    const guest = !isAdmin ? guests[activeGuest] : props.guest;

    const validate = () => {
        const passportOk = guest.documents.filter((doc) => doc.type === 'passport').length > 0;
        const accreditationOk = guest.documents.filter((doc) => doc.type === 'accreditation').length > 0;

        setPassportError(passportOk ? '' : TextTranslateString('docs-passport-error', 'Please upload passport!', props.currentLanguage, props.translations));
        setAccreditationError(accreditationOk ? '' : TextTranslateString('docs-accreditation-error', 'Please upload accreditation photo!', props.currentLanguage, props.translations));

        return passportOk && accreditationOk;
    }

    const handlePrevious = () => {
        props.dispatch(prevStepAction());
    }

    const handleNext = () => {

        if (!validate()) {
            return;
        }

        props.dispatch(nextStepAction());
    }

    if (!guest) {
        return <></>;
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h3><TextTranslate name="docs-passport" fallback="Passport" textOnly/></h3>
                    <p><TextTranslate name="docs-passport-note" fallback="Please upload a copy of your passport as an image. This is a requirement to confirm your hotel room and accreditation." textOnly /></p>
                    {passportError && (
                        <div className="alert alert-danger" role="alert">
                            {passportError}
                        </div>
                    )}
                    <DocumentUploader
                        guest={guest}
                        type="passport"
                        onChange={props.onChange}
                        isAdmin={isAdmin}
                    />
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-12">
                    <h3><TextTranslate name="docs-accreditation-photo" fallback="Accreditation Photo" textOnly/></h3>
                    <p><TextTranslate name="docs-accreditation-photo-note" fallback="Please upload a headshot image which will be used for your race event accreditation." textOnly/></p>
                    {accreditationError && (
                        <div className="alert alert-danger" role="alert">
                            {accreditationError}
                        </div>
                    )}
                    <DocumentUploader
                        guest={guest}
                        type="accreditation"
                        onChange={props.onChange}
                        isAdmin={isAdmin}
                    />
                </div>
            </div>

            {!isAdmin ?
                <StepsNavigation
                    fnPrevious={handlePrevious}
                    fnNext={handleNext}
                /> : null
            }
        </>
    )
}

const mapStateToProps = (state) => ({
    guests: state.guests?.list,
    activeGuest: state.guests?.activeGuest,
    activeStep: state.guests?.activeStep,
    formData: state.guests?.formData,
    currentLanguage: state.translations?.currentLanguage,
    translations: state.translations?.translations
});

export default connect(mapStateToProps)(Documents);
